import { Card } from "components";
import FormError from "pages/accounts-onboarding/components/form-error/FormError";
import React from "react";

import RegisterFooter from "./RegisterFooter";
import RegisterFormBody from "./RegisterFormBody";
import RegisterHeader from "./RegisterHeader";

import styles from "../Register.module.css";

const RegisterForm = () => {
	return (
		<Card className={styles.card}>
			<div className={styles.form}>
				<RegisterHeader />
				<FormError />
				<RegisterFormBody />
				<RegisterFooter />
			</div>
		</Card>
	);
};

export default RegisterForm;
